module.exports = __webpack_public_path__ + "img/banner.0ab50cd9.jpg";